import React from 'react';
export function PatternReveal() {
  const steps = [{
    num: 1,
    text: 'Pide claridad.'
  }, {
    num: 2,
    text: 'Él minimiza.'
  }, {
    num: 3,
    text: 'Ella se enoja (porque le están moviendo el piso).'
  }, {
    num: 4,
    text: 'Él la llama exagerada, intensa, loca.'
  }, {
    num: 5,
    text: 'Ella termina pidiendo perdón… por reaccionar.'
  }];
  return <section className="w-full bg-white px-6 py-16 md:py-24" data-id="element-101">
      <div className="mx-auto max-w-3xl" data-id="element-102">
        <h2 className="mb-10 text-center text-3xl font-bold text-[#2D2420] md:text-4xl" data-id="element-103">
          Se llama{' '}
          <span className="italic text-[#C4704B]" data-id="element-104">“No Estoy Loca”</span> por una
          razón
        </h2>

        <p className="mb-8 text-lg text-[#2D2420]" data-id="element-105">
          Porque cuando una mujer descubre una traición, casi siempre pasa lo
          mismo:
        </p>

        <div className="mb-12 space-y-4 rounded-xl bg-[#FFFBF5] p-8 ring-1 ring-[#E8DDD4]" data-id="element-106">
          {steps.map(step => <div key={step.num} className="flex items-start gap-4" data-id="element-107">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#C4704B] font-serif font-bold text-white" data-id="element-108">
                {step.num}
              </span>
              <p className="pt-0.5 text-lg text-[#2D2420]" data-id="element-109">{step.text}</p>
            </div>)}
        </div>

        <div className="mx-auto max-w-xl text-center" data-id="element-110">
          <p className="mb-6 text-xl font-medium text-[#2D2420]" data-id="element-111">
            Y ahí empieza la condena silenciosa:{' '}
            <span className="border-b-2 border-[#C4704B]" data-id="element-112">la culpa.</span>
          </p>

          <div className="mb-8 grid grid-cols-1 gap-3 text-left md:grid-cols-2" data-id="element-113">
            {['Culpa por revisar.', 'Culpa por preguntar.', 'Culpa por llorar.', 'Culpa por quedarte.', 'Culpa por querer irte.'].map((item, i) => <div key={i} className="flex items-center gap-2 text-[#8B7D75]" data-id="element-114">
                <div className="h-1.5 w-1.5 rounded-full bg-[#C4704B]" data-id="element-115" />
                <span data-id="element-116">{item}</span>
              </div>)}
          </div>

          <p className="mb-10 text-lg italic text-[#2D2420]" data-id="element-117">
            Como si el daño se borrara si tú te vuelves “mejor”.
          </p>

          <div className="rounded-lg bg-[#FFF3E8] p-6 text-center" data-id="element-118">
            <h3 className="mb-4 font-serif text-2xl font-bold text-[#C4704B]" data-id="element-119">
              Este PDF existe para cortar esa culpa.
            </h3>
            <ul className="space-y-2 text-[#2D2420]" data-id="element-120">
              <li data-id="element-121">Sin frases bonitas.</li>
              <li data-id="element-122">Sin moralismos.</li>
              <li data-id="element-123">Sin “échale ganas”.</li>
              <li className="font-medium" data-id="element-124">
                Con un protocolo corto que haces en 15–20 minutos al día.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}